module.exports = __webpack_public_path__ + "img/u28535.915141ea.svg";